import type { ErrorInfo } from 'react';

import { trackError } from './trackError';
import type { RUMCustomErrorContext } from './types';

function wrapComponentError(error: Error, info: ErrorInfo) {
  const renderingError = new Error(error.message);
  renderingError.name = 'ReactRenderingError';
  renderingError.stack = info.componentStack || undefined;
  renderingError.cause = error;

  return renderingError;
}

export function trackComponentError(
  error: Error,
  info: ErrorInfo,
  { isCrash, severity, url, owner }: RUMCustomErrorContext = {},
) {
  trackError(wrapComponentError(error, info), { isCrash, severity, url, owner });
}
